import { typography } from "src/utils/styledComponents/typography";
import styled from "styled-components/macro";
import { Button as AntButton } from "antd";
import { theme } from "src/theme/theme";
import { colors } from "src/theme/colors";
import { line, radii } from "src/theme/ui";
import { fieldHeight } from "src/components/ui/field";
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
`;

/* Kept for the pages that still pass a title, but no longer the centred
   accent serif heading it was: these pages now open with the product's own
   page header, and a second title inside the card said the same thing again
   in a different typeface. */
export const Title = styled.h2`
  display: none;
`;

export const SubTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: ${colors.gray[900]};
`;

/**
 * The form column.
 *
 * It was 50% of the card above 1581px and 80% below, centred — so on a
 * fifteen-hundred-pixel screen the form was a 290px ribbon in the middle of
 * a wide white card, and its own fields were narrower than the labels above
 * them. A form reads best at a bounded measure, so it takes one: wide enough
 * for a select and an amount side by side, and no wider.
 */
export const Wrapper = styled.div<{
  leanWrapper?: boolean;
  /** In a dialog the form takes the dialog's own measure. */
  $full?: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ $full }) => ($full ? "none" : "560px")};
`;

export const Information = styled.div`
  display: flex;
  flex-direction: column;
`;

/* A group's name, in ink at a legible size. It was 12px of accent blue at
   80% opacity over 12px of black at 50% — two washed-out greys, one of them
   a faded brand colour, for the line that says what the choice below it
   is. */
export const Text = styled.div`
  ${typography.CustomText("0.8125rem")}
  font-weight: 600;
  color: ${colors.gray[800]};
`;

export const SubText = styled.div`
  ${typography.CustomText("0.8125rem")}
  margin-top: 2px;
  line-height: 1.5;
  color: ${colors.gray[500]};
`;

/* The next field carries its own top margin, so this only needs enough to
   clear the cards — the two together were forty pixels between the method
   you picked and the account you pick next. */
export const RadioContainer = styled.div`
  margin-top: 10px;
`;

/* The fields. No bottom margin: what follows them is the actions band, which
   brings its own clearance — the two together put thirty-six pixels of white
   between the amount and the rule above the buttons. */
export const FormItem = styled.div`
  margin-top: 14px;
`;

/**
 * "New bank account", as a secondary action.
 *
 * It was a full-width button on an accent tint inside a 2px accent border,
 * directly above the form's own primary — so the loudest control on a page
 * whose purpose is to deposit money was the one that adds a bank account.
 * A second edge that thick reads as a primary whatever colour it is filled
 * with. The product's secondary button: one hairline, ink label, sized to
 * its own text.
 */
export const AddButton = styled(AntButton)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  align-self: flex-start;
  height: ${fieldHeight.field}px;
  padding: 0 14px;
  border: 1px solid ${line.field};
  border-radius: ${radii.control}px;
  background: ${colors.white};
  color: ${colors.gray[800]};
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: none;

  &.ant-btn:hover,
  &.ant-btn:focus,
  &.ant-btn:active {
    border-color: ${colors.gray[300]} !important;
    background: ${colors.gray[50]} !important;
    color: ${colors.gray[900]};
  }

  svg {
    width: 15px;
    height: 15px;
  }
`;
